<main class="file-from-process">
	<div class="inline-flex items-center mb-[12px] ng-star-inserted">
		<p class="text-font text-xs">{{ labelValue }}</p>
	</div>
	@if (!loadPage) {
		<div class="relative pt-[64px]">
			<lbca-loading position="absolute"></lbca-loading>
		</div>
	}

	@if (loadPage && !(selectedFile || currentFile)) {
		<div class="ffp-container">
			<div class="ico-file-search"></div>
			<button
				type="button"
				[id]="buttonId"
				(mouseenter)="showErrorRequerid()"
				(mouseleave)="removeErrorRequerid()"
				[class.error]="hasErrorRequired"
				class="btn-primary btn-type-2"
				(click)="searchFiles()"
			>
				{{ buttonLabelValue }}
			</button>
		</div>
	}

	@if (loadPage && (currentFile || selectedFile)) {
		<div class="inline-flex items-center">
			@if (currentFile?.remove && !isSaving) {
				<div class="file-actions-container pr-[20px]">
					<label class="file-delete" (click)="confirmDelete(currentFile)">
						<div class="iconrenderer trash bg-gray-600"></div>
					</label>
				</div>
			}
			@if (isSaving) {
				<div class="file-actions-container">
					<img class="forgot-loading" src="./assets/icons/loading-points-bg-primary.svg" />
				</div>
			}
			@if (selectedFile) {
				<div class="flex items-center mr-[16px] opacity-30">
					<img src="{{ selectedFile.icon }}" class="cursor-pointer" />
					<span class="no-select text ml-[6px] cursor-pointer text text-font text-xs">
						{{ selectedFile.fileName }}
					</span>
				</div>
			}
			@if (!selectedFile && currentFile) {
				<div class="flex items-center mr-[16px]">
					<img src="{{ currentFile.icon }}" class="cursor-pointer" />
					<span class="no-select text ml-[6px] cursor-pointer text text-font text-xs">
						{{ currentFile.fileName }}
					</span>
				</div>
			}
			@if (!isSaving) {
				<div class="file-actions-container pr-[20px]">
					<label class="file-delete" (click)="deleteItem(currentFile)">
						@if (!currentFile.remove) {
							<div class="iconrenderer trash bg-gray-600"></div>
						}
						@if (currentFile.remove) {
							<div class="iconrenderer error bg-gray-600"></div>
						}
					</label>
				</div>
			}
		</div>
	}
</main>

<ng-template #FilesTemplate>
	@if (!loadedFiles) {
		<div class="relative h-full">
			<lbca-loading position="absolute"></lbca-loading>
		</div>
	}
	<main>
		@if (loadedFiles) {
			<section class="bg-gray-100 rounded-lg flex flex-col modal-padding">
				<lbca-table [table]="table" (clickLine)="uploadFile($event)"></lbca-table>
			</section>
		}
		<section class="file-from-process-buttons">
			<button class="btn-secondary btn-type-2" (click)="cancel()">Cancelar</button>
		</section>
	</main>
</ng-template>

<ng-template #uploadButton let-file>
	<div class="flex items-center min-h-[40px] bg-gray-50">
		<!-- <label class="btn-download">
    <a (click)="uploadFile($event, file);"></a>
  </label> -->
	</div>
</ng-template>

<ng-template #name let-file>
	<div class="flex items-center w-full min-h-[40px] bg-gray-50">
		<img src="{{ file.icon }}" />
		<span class="no-select text text-xs ml-[12px]">{{ file.fileName }}</span>
	</div>
</ng-template>

<ng-template #templateRemove>
	<div class="text-base text-font flex items-center justify-center show">
		Arquivo excluído!
		<div class="emojis-wastebasket icon-box ml-[16px]"></div>
	</div>
</ng-template>

<ng-template #templateRemoveError>
	<div class="text-base text-font flex items-center justify-center show">
		Erro ao tentar excluir o arquivo!
		<div class="emojis-wastebasket icon-box ml-[16px]"></div>
	</div>
</ng-template>

<ng-template #sizeFeedback let-file>
	<span class="text text-xs">{{ formatBytes(file.size) }}</span>
</ng-template>
